import { Search as SearchIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import React, { ChangeEvent, KeyboardEvent, useEffect, useState } from 'react';

import { SearchAreaProps } from './SearchArea.interface';
import { StyledInput } from './SearchArea.styled';

export const SearchArea: React.FC<SearchAreaProps> = (props) => {
  const [inputValue, setInputValue] = useState('');

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      const newTerms = inputValue
        .split('\n')
        .filter((term) => term.trim() !== '')
        .filter((term) => !props.searchTerms.includes(term));

      if (newTerms.length > 0 && props.onChange) {
        props.onChange([...props.searchTerms, ...newTerms]);
      }
      setInputValue('');
    }
  };

  useEffect(() => {
    if (props.resetVal) {
      setInputValue('');
      if (props.onResetComplete) {
        props.onResetComplete();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.resetVal, props.onResetComplete]);

  return (
    <StyledInput
      maxRows={8}
      multiline
      InputProps={{
        startAdornment: (
          <IconButton size="small">
            <SearchIcon />
          </IconButton>
        ),
      }}
      placeholder="Filter"
      value={inputValue}
      onChange={(event: ChangeEvent<HTMLInputElement>) =>
        setInputValue(event.target.value)
      }
      onKeyDown={handleKeyDown}
    />
  );
};
